const HEIGHT_MULTIPLIERS = {
    '100%': 1,
    '75%': 0.75,
    '50%': 0.5
}

const getScaledHeight = (height, selectedHeight) =>
    Math.round(height * getHeightMultiplier(selectedHeight))

export const getHeightMultiplier = (height = '100%') => HEIGHT_MULTIPLIERS[height] ?? 1

export const getScaledSize = (size, selectedHeight) => ({
    ...size,
    height: getScaledHeight(size.height, selectedHeight)
})
